import { useCallback, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate, useLocation } from 'react-router-dom';

import AutoSignin from '@/features/auth/components/auto-signin';
import { SIGNIN_REDIRECT_URL_KEY } from '@/features/auth/config/oidc';
import { useReferralPostMutation } from '@/hooks/queries/use-referral';
import { getReferralCode } from '@/utils/referral';
import LoadingPage from './loading';

const RegistrationSuccessPage = () => {
  const { isAuthenticated, isLoading: isLoadingAuth } = useAuth();
  const { isIdle: isIdlePostReferral, isPending: isPendingPostReferral, mutate: postReferral } = useReferralPostMutation();
  const location = useLocation();
  const referralCode = getReferralCode();
  const shouldPostReferral = isAuthenticated && !!referralCode;
  const isLoading = isLoadingAuth || (shouldPostReferral && (isIdlePostReferral || isPendingPostReferral));

  const handleBeforeSignin = useCallback(() => {
    window.sessionStorage.setItem(SIGNIN_REDIRECT_URL_KEY, location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (!shouldPostReferral) return;

    postReferral(referralCode);
  }, [postReferral, referralCode, shouldPostReferral]);

  if (isLoading) return <LoadingPage />;

  if (!isAuthenticated) {
    return <AutoSignin onBeforeSignin={handleBeforeSignin} />;
  }

  return <Navigate to="/onboarding" replace />;
};

RegistrationSuccessPage.displayName = 'RegistrationSuccessPage';

export default RegistrationSuccessPage;
